<template>
  <div class="flex items-center">
    <Link
      :href="href"
      class="inline-flex items-center text-gray-800 hover:text-gray-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
    >
      <BackArrow />
      <h2 class="inline font-semibold text-xl text-gray-800 leading-tight ml-2 mb-2">
        <slot name="label">
          {{ label }}
        </slot>
      </h2>
    </Link>
    <template v-if="$slots.subtitle">
      <div class="ml-5 mb-2">
        <slot name="subtitle" />
      </div>
    </template>
    <p v-else-if="subtitle" class="ml-5 text-gray-600 font-semibold text-xl mb-2">
      {{ subtitle }}
    </p>
    <slot />
  </div>
</template>

<script>
import BackArrow from '@/components/BackArrow.vue';

export default {
  components: {
    BackArrow,
  },
  props: {
    href: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    subtitle: {
      type: [String, Number],
      default: '',
    },
  },
};
</script>
